export default () => ({
  statesAccount: {
    search: {
      rucOrName: "",
      isLoading: false,
      data: {
        data: []
      },
      select: {},
      fileUrlExcel: null,
      fileUrl: null
    },
  },
  paymentsHistory: {
    search: {
      rucOrName: "",
      isLoading: false,
      data: {},
      error: "",
      client: null
    },
    modals: {
      infoBehavior: {
        isOpen: false,
        selected: null,
        data: {}
      },
    },
    score: null
  },
  // Facturas al contado: la usan admin y ventas con la misma vista.
  cashBilling: {
    search: {
      rucOrName: "",
      startDate: "",
      endDate: "",
      isLoading: false,
      isExporting: false,
      data: {
        data: []
      },
      searched: false,
      send: {
        isOpen: false,
        element: null,
        channel: "whatsapp",
        recipient: "",
        cc: "",
        // WhatsApp: país del celular (código) y código manual si es «Otro país».
        phoneCountry: "51",
        phoneCode: "",
        error: "",
        isSending: false,
        contact: null,
        // Correo: asunto y mensaje editables, con el texto predeterminado de la API.
        subject: "",
        message: "",
        attachments: [],
        preview: null,
        isLoadingPreview: false
      },
      // Aviso compartido entre la tabla, el cuadro de envío y la vista.
      notice: {
        isShow: false,
        message: "",
        messageType: ""
      }
    },
  },
  // Directorio de contactos de contado (pantalla de administración).
  cashContacts: {
    search: "",
    isLoading: false,
    isSaving: false,
    data: {
      data: []
    },
    form: {
      isOpen: false,
      isNew: true,
      ruc: "",
      name: "",
      email: "",
      cellphone: "",
      error: ""
    }
  }
});
